var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeploySvgrepocom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_3063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 4.0625L34.5312 16.25L37.4047 19.0984L44.6875 11.8186V56.875H12.1875V24.375H8.125V56.875C8.12634 57.952 8.55479 58.9846 9.31636 59.7461C10.0779 60.5077 11.1105 60.9362 12.1875 60.9375H44.6875C45.7645 60.9362 46.7971 60.5077 47.5586 59.7461C48.3202 58.9846 48.7487 57.952 48.75 56.875V11.8125L56.0339 19.0984L58.9062 16.25L46.7188 4.0625Z",
    fill: "#307BC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6589 51.2197L25.5836 44.2172C26.7732 44.7506 28.0908 45.0479 29.4785 45.0479C34.7384 45.0479 39.0026 40.7831 39.0026 35.5244C39.0026 30.2648 34.7384 26 29.4785 26C24.2187 26 19.9545 30.2648 19.9545 35.5244C19.9545 38.0875 20.9677 40.4155 22.6151 42.1269L17.6895 49.1312C16.3175 51.0811 19.2869 53.1706 20.6589 51.2197Z",
    fill: "#307BC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_3063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploySvgrepocom);
export default __webpack_public_path__ + "static/media/deploy_svgrepo.com.3296d6cffa1536bce3a22762bb986cda.svg";
export { ForwardRef as ReactComponent };